import {getLayoutData, getPageData, getPages} from "@/pages/api/api";
import {
	DRAGGABLE_LETTERS_BANNER_QUERY,
	GLOBAL_BASED_BANNER_QUERY,
	RECAP_INFO_QUERY,
	RECAP_SUMMARY_ITEM_QUERY,
	SEE_ALSO_INFO_BLOCK_QUERY,
	SEO_QUERY,
	SINGLE_BE_WITH_US_PAGE_QUERY,
} from "@/pages/api/fragments";
import {gsap, ScrollTrigger} from "@/utils/gsap";
import ExtendedContent from "@/components/common/ExtendedContent";
import SeeAlso, {getSeeAlsoData} from "@/components/SeeAlso";
import {useMemo} from "react";
import Recap from "@/components/Recap";
import {formatContentWithRecap} from "@/utils/utils";
import SubPageBanner from "@/components/Banners/SubPage/SubPageBanner";
import {CONTENT_TYPES} from "@/constants";

gsap.registerPlugin(ScrollTrigger)

export default function BWUPage({ data, globals }) {
	const content = useMemo(() => formatContentWithRecap(data?.content || []), [data.content])
	const seeAlsoInfo = data?.seeAlsoInfo || { header: '', variant: ''}
	const formattedSeeAlsoData = useMemo(() => getSeeAlsoData(data),[data])

	const bannerData = data?.banner || null

	return (
		<>
			<SubPageBanner data={bannerData} />
			<Recap />
			<ExtendedContent
				content={content}
				globals={globals}
			/>
			<SeeAlso
				header={seeAlsoInfo.header}
				variant={seeAlsoInfo.variant}
				data={formattedSeeAlsoData}
			/>
		</>
	)
}

const TYPE = 'allSingleBeWithUsPages'

const pathsQuery = `
	query GetSingleBeWithUsPageData($locale: SiteLocale) {
		${TYPE}(locale: $locale, first: 500) {
            slug
            category{
            	slug
            }
		}
	}
`;

const propsQuery = `
	query GetSingleBeWithUsPageData($slug: String, $locale: SiteLocale)  {
		${TYPE}(locale: $locale, filter: {slug: {eq: $slug}}) {
			__typename
            name
            slug
            category{
            	slug
            }
            ${SEO_QUERY}
            banner {
            	${GLOBAL_BASED_BANNER_QUERY}
            	${DRAGGABLE_LETTERS_BANNER_QUERY}
            }
            recapInfo{
			 	${RECAP_INFO_QUERY}
			} 
			content{
				${RECAP_SUMMARY_ITEM_QUERY}
			}
			seeAlsoInfo{
				${SEE_ALSO_INFO_BLOCK_QUERY}
			}
			seeAlsoLinks {
				... on ${CONTENT_TYPES.SINGLE_BE_WITH_US_PAGE} {
					${SINGLE_BE_WITH_US_PAGE_QUERY}
				}
			}
        }
    }
`

export async function getStaticProps({ params, locale }) {
	const { bwu } = params;
	const data = await getPageData(TYPE, bwu, propsQuery, locale);
	const layout = await getLayoutData(locale)
	return {
		props: {
			data,
			locale,
			...layout,
			isDarkSearch: true,
			isSingleBeWithUs: true,
		},
		revalidate: 60 * 60
	};
}

export async function getStaticPaths({ locales, ...props }) {
	const paths = (
		await Promise.all(
			locales.map(async (locale) => {
				const pages = await getPages(TYPE, pathsQuery, locale);
				return pages.map((page) => ({
					params: {
						bwu: page.slug,
						slug: page.category.slug
					},
					locale,
				}));
			}),
		)
	).flat();
	return {
		paths,
		fallback: false,
	};
}
